import { render, staticRenderFns } from "./question-temp.vue?vue&type=template&id=3dcfe266&scoped=true"
import script from "./question-temp.vue?vue&type=script&lang=ts"
export * from "./question-temp.vue?vue&type=script&lang=ts"
import style0 from "./question-temp.vue?vue&type=style&index=0&id=3dcfe266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcfe266",
  null
  
)

export default component.exports